// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"Paragraph_paragraph__xt7qj","altFont":"Paragraph_altFont__2pwJ1","left":"Paragraph_left__2Hpho","center":"Paragraph_center__1RABU","right":"Paragraph_right__14Sd9"};